export default function composerNameToID(name) {
  return name.toLowerCase().split('(')[0].replace(/\s+/g, '');
}
